module.exports = __webpack_public_path__ + "static/img/nav_3.8d52ddc.svg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/nav_3.svg
// module id = oHTA
// module chunks = 2